<template src="./Receipt.html">
</template>
<script>
export default {
  created() {
    let id = this.$route.params.id;
    this.$store
      .dispatch("treasury/getForReceipt", id)
      .then((res) => {
        
        this.item = res.patientsPayment;
        this.patientQR = res.imageQR;
      }).catch(() => { });
  },
  data() {
    return {
      item: {},
      patientQR:null

    };
  },
  methods: {
    printReceipt() {
      window.print(); // فتح نافذة الطباعة
    },
  },
};
</script>
<style>
.contact-footer {
  position: absolute;
  bottom: 5px;
  /* يضمن الابتعاد عن الحافة السفلية */
  left: 0;
  right: 0;
  font-size: 14px;
  color: #555;
  /* لون النص */
}

.clinic-name {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  /* لون أزرق غامق */
  margin: 0;
}

.receipt-title {
  font-size: 16px;
  font-weight: bold;
  color: #83c783;
  /* لون أزرق */
}

/* تهيئة التصميم للطباعة بحجم A5 */
.receipt-a5 {
  width: 148mm;
  /* عرض A5 */
  min-height: 210mm;
  /* ارتفاع A5 */
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

/* إعداد الطباعة */
@media print {
  .receipt-a5 {
    box-shadow: none;
    margin: 0;
  }

  body {
    margin: 0;
  }

  .v-btn {
    display: none;
    /* إخفاء زر الطباعة عند الطباعة */
  }
}

.text-h6 {
  color: #83c783;
}

h4,
h5,
span {
  font-family: "Almarai";
}

.text-caption {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}
</style>

